module.exports = __webpack_public_path__ + "static/media/41_B.efa388c2.png";